<template>
     
   <!-- <div class="signup">-->
      <v-flex xs12 sm12 md12 lg12 xl12 class="signup">
        <v-container>
  <div class='pattern'></div>
  <v-layout class="tiranaranja" justify-end >
    <img class="hidden-xs-only" src="elementos-pantalla-azulcielo-14.png" >
    <img class="hidden-sm-and-up" src="elementos-pantalla-azulcielo-14.png" height="150px" style="margin-top:30%">
  </v-layout>

<v-layout class="divlogin" row justify-center >
  
<v-form v-model="valid" class="formlogin" style="background-color:#263971;  width:90%; border-radius:20px">
    <v-container>
      <v-layout row wrap justify-center class=" pt-3">
          <v-flex
          xs12
          md4
          lg5
        >
          <v-text-field
            v-model="email"
            :rules="emailRules"
            label="usuario@gmail.com"
            required
            solo
            prepend-inner-icon="person"
            flat
            style="background:white; border-radius:8px" class="pa-1"
          ></v-text-field>
          <!--<correo :email="email"></correo>-->
        </v-flex>

        <v-flex
          xs12
          md4
          lg5
        >
        
           
          <v-text-field
            v-model="password"
            :append-icon="show3 ? 'visibility' : 'visibility_off'"
            :rules="[rules.required, rules.min]"
            :type="show3 ? 'text' : 'password'"
            name="input-10-2"
            label="Contraseña"
            hint="At least 6 characters"
            style="background:white; border-radius:8px;"
            solo
            flat
            prepend-inner-icon="lock"
            
            class="input-group--focused pa-1"
            @click:append="show3 = !show3"
          ></v-text-field>
          <br>
          <span class="confirmpasstext" >Confirmar contraseña</span>
          <br>
          <v-text-field
            v-model="confirm_password"
            :append-icon="show4 ? 'visibility' : 'visibility_off'"
            :rules="[rules.required, rules.min]"
            :type="show4 ? 'text' : 'password'"
            name="input-10-2"
            label="Confirmar Contraseña"
            hint="At least 6 characters"
            style="background:white; border-radius:8px;"
            solo
            flat
            prepend-inner-icon="lock"
            
            class="input-group--focused pa-1"
            @click:append="show4 = !show4"
          ></v-text-field>
          <br>
          <div class="text-xs-center">
          <v-btn
          large
      color="#4ba96c"
      @click="guardarinfo()"
      
      class="text-none loginbutton"
      style="color:white"
    >
      Confirmar
    </v-btn>
    </div>
    <br>
        </v-flex>
        
        
      </v-layout>
      <v-layout justify-center>

      

      </v-layout>
    </v-container>
  </v-form>
</v-layout>
<v-layout class="pl-5 mrosa">
  <img class="hidden-xs-only" src="mrosa.png">
  <img class="hidden-sm-and-up" src="mrosa.png" height="150px">
</v-layout>

<!--</div>-->
</v-container>
      </v-flex>


</template>


<script>



export default {
    
    data () {
      return {
        show3: false,
        show4:false,
        valid:false,
        password: '',
        confirm_password:'',
        rules: {
          required: value => !!value || 'Required.',
          //min: v => v.length >= 8 || 'Min 8 characters',
          //emailMatch: () => ('The email and password you entered don\'t match')
        },
        email: "",
        emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid'
      ]
      }
      
    },
    methods:{
      guardarinfo: function(){
          var email = this.email; 
          var patron=/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,4})+$/ ;

         if (this.email =="" || this.password =="" || this.confirm_password =="") {
              alert("Llenar campos correctamente");
              return;
          }else if(email.search(patron)!=0){
              alert("Direccion de correo incorrecta");
          }
          else if(this.password != this.confirm_password){
            alert("Las contraseñas no coinciden")
          }else if(this.password.length<=5){
              alert("Ingresa una contraseña mas larga")
          }
          
          else{
            if (typeof(Storage) !== 'undefined') {
              let user = this.email
              let password = this.password
              localStorage.Email = user
              localStorage.Password = password
            } else {
             alert("localstoragge no funciona")
           }
            this.$router.push('/Code')
          }
        
      },
      testsStorage: function(){   
        if (typeof(Storage) !== 'undefined') {
         let correo = localStorage.User 
         this.email = correo
        } else {
          alert("localstoragge no funciona")
        }
      }
    },
    beforeMount(){
      this.testsStorage()
    }
    
}
</script>


<style>

@media (min-width: 1200px){
  .confirmpasstext{
    color:white; 
    font-size:1.2vw; 
    font-family:Poppins; 
    font-weight:500
  }
}

@media (min-width: 300px) and (max-width: 750px){
  .confirmpasstext{
    color:white; 
    font-size:4vw; 
    font-family:Poppins; 
    font-weight:500
  }
}
</style>